interface KpiChartCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

/** Bordered card wrapping a titled chart inside a model panel. */
export const KpiChartCard = ({
  title,
  description,
  children,
}: KpiChartCardProps) => (
  <div className="rounded-xl border border-gray-DBDFE9 bg-white p-5">
    <h3 className="mb-1 text-md font-semibold text-black-071336">{title}</h3>
    <p className="mb-4 text-xs text-gray-78829D">{description}</p>
    {children}
  </div>
);
